import { useEffect, useState, type ReactNode } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { createPwaRuntime } from './runtime'
import { VersionNotice } from './version-notice'

/** Mounts the PWA runtime (version checks, safe update, drafts identity) and the global VersionNotice. Rendered from main.tsx. */
export function PwaProvider({ children }: { children?: ReactNode }) {
  const queryClient = useQueryClient()
  const [runtime] = useState(() => createPwaRuntime(queryClient))
  useEffect(() => runtime.start(), [runtime])
  return (
    <>
      {children}
      <VersionNotice manager={runtime.manager} chunk={runtime.chunk} />
    </>
  )
}
